// components/Dashboard/Tabs.jsx

import React from 'react';

function Tabs({ selectedTab, setSelectedTab, hidePlayerSettings = false, liveExperienceOwned = false }) {
  return (
    <div className="dashboard-tabs">
      <button
        className={`tab-button ${selectedTab === 'Now Playing' ? 'active' : ''}`}
        onClick={() => setSelectedTab('Now Playing')}
      >
        Now Playing
      </button>
      {!hidePlayerSettings && !liveExperienceOwned && (
        <button
          className={`tab-button ${selectedTab === 'Player Settings' ? 'active' : ''}`}
          onClick={() => setSelectedTab('Player Settings')}
        >
          Player Settings
        </button>
      )}
      <button
        className={`tab-button ${selectedTab === 'TV Remote' ? 'active' : ''}`}
        onClick={() => setSelectedTab('TV Remote')}
      >
        TV Remote
      </button>
    </div>
  );
}

export default Tabs;
